/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import LocationService from '../../services/locationService';
import ArtistService from '../../services/artistService';
import * as textUtils from '../../utils/textUtils';
import ToastrService from '../../services/toastrService';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import * as browserCheck from '../../utils/browserCheck.js';
import MaterialInput from '../common/MaterialInput.js';
import MaterialDropDown from '../common/MaterialDropDown.js';
/* global google */

class EditSeeMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.editGig = this.editGig.bind(this);
        this.removeGig = this.removeGig.bind(this);
        this.addGig = this.addGig.bind(this);
        this.showAdd = this.showAdd.bind(this);
        this.closeShowAdd = this.closeShowAdd.bind(this);
        this.updateGig = this.updateGig.bind(this);   
        this.closeEditGig = this.closeEditGig.bind(this);
        this.updateSelectedGigField = this.updateSelectedGigField.bind(this);
        this.updateNewGigField = this.updateNewGigField.bind(this);   
        this.initialiseVenueAutoCompleteNewGig = this.initialiseVenueAutoCompleteNewGig.bind(this);        
        this.initialiseVenueAutoCompleteSelectedGig = this.initialiseVenueAutoCompleteSelectedGig.bind(this);
        this.processPlaceGigVenue = this.processPlaceGigVenue.bind(this);
        this.initialiseDatePickers = this.initialiseDatePickers.bind(this);
        this.state = {
            profile: this.props.profile,
            gigs: [],
            loadingGigs: false,
            showAdd: false,
            uploadingGig: false,
            selectedGig: null,
            newGig: {},            
            locationTypeaheadLoading: false,
            locationTypeaheadOptions: [],
            locationFocused: false,
            dateFocusedInput: null
        };
     }

    componentWillMount() {
        if(!this.props.countries.length) {
            this.props.actions.getCountries();
        }
        this.initialise();
    }

    componentDidMount() { 
        if (browserCheck.canUseDom()) {
            this.initialiseDatePickers();
        }    
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                gigs: [],
                selectedGig: null
            }, this.initialise);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const showingSelectedGig = this.state.selectedGig && !prevState.selectedGig;
        const showingAddGig = this.state.showAdd && !prevState.showAdd;
        if(showingSelectedGig || showingAddGig) {
            window.componentHandler.upgradeDom();  
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#divCreateProfile .getmdl-select, #editGig .getmdl-select');   
            if(showingSelectedGig && this.state.selectedGig.Country) {
                this.initialiseVenueAutoCompleteSelectedGig();
            }
            this.initialiseDatePickers();
        }    
    }

    initialise(clearProfileGigs = false) {
        this.setState({ loadingGigs: true, selectedGig: null, error: null });        
        this.props.actions.getGigs(this.state.profile.ID)
            .then(gigs => {
                this.setState({ loadingGigs: false, gigs });
                if(clearProfileGigs) {
                    this.props.actions.clearProfileGigs(this.state.profile.ID, this.state.profile.Username);
                }
            })
            .catch(error => this.setState({ loadingGigs: false }));
    }

    initialiseDatePickers() {
        //we need this for the date picker
        //https://github.com/T00rk/bootstrap-material-datetimepicker
        window.moment = moment;
        const bootstrapMaterialDatePicker = require('bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker.js');
        if(this.startDateControl) {
        $(this.startDateControl).bootstrapMaterialDatePicker({ 
                time: true,
                minDate: moment(),
                switchOnClick: true
            }).on('change', (e, date) => {
                e.preventDefault();
                e.stopPropagation();
                const gig = this.state.showAdd ? {...this.state.newGig} : {...this.state.selectedGig};
                gig.StartDate = date;
                if(gig.EndDate && gig.EndDate < gig.StartDate) {
                    gig.EndDate = null;
                }
                $(this.endDateControl).bootstrapMaterialDatePicker('setMinDate', date);
                if(this.state.showAdd) {
                    this.setState({ newGig: gig });      
                }
                else {
                    this.setState({ selectedGig: gig });
                }
            });
        }
        $(this.endDateControl).bootstrapMaterialDatePicker({ 
            time: true,
            minDate: moment(),
            switchOnClick: true
        }).on('change', (e, date) => {
            e.preventDefault();
            e.stopPropagation();
            const gig = this.state.showAdd ? {...this.state.newGig} : {...this.state.selectedGig};
            gig.EndDate = date;
            if(this.state.showAdd) {
                this.setState({ newGig: gig });      
            }
            else {
                this.setState({ selectedGig: gig });
            }         
        });
    }

    editGig(event, gig) {
        event.preventDefault();
        gig = {...gig};
        gig.StartDate = moment(gig.StartDate);
        if(gig.EndDate) {
            gig.EndDate = moment(gig.EndDate);
        }
        //translate back from the country name to code
        gig.Country = this.props.countries.find(c => c.Name === gig.Country).Code;
        this.setState({ selectedGig: gig, error: null, uploadError: null });
    }

    closeEditGig(event) {
        event.preventDefault();
        this.initialise();
    }

    removeGig(event, gig) {
        event.preventDefault();
        if(confirm(`Remove gig '${gig.Title}' from your LoudUp page?`)) {
            this.props.actions.deleteGig(this.state.profile.ID, gig.ID)
                .then(_ => {
                   this.initialise(true);
                   const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'The gig has been removed successfully');
                })
                .catch(error => {
                    this.setState({ error: 'Sorry, something went wrong, unable to delete gig' });
                });
        }
        else {
            return false;
        }
    }

    addGig(event) {      
        event.preventDefault();
        if(!this.state.newGig.Country) {
            this.setState({ error: "Please enter the event country" });
        }
        else if(!this.state.newGig.City) {
            this.setState({ error: "Please enter the event location" });
        }
        else if (!this.state.newGig.StartDate) {
            this.setState({ error: "Please enter the event date" });
        }
        else {
            this.setState({ error: null });
            const gig = {...this.state.newGig};            
            this.props.actions.addGig(this.state.profile.ID, gig)
                .then(gig => {
                    const gigs = [...this.state.gigs].concat(gig);   
                    this.setState({ gigs, newGig: { }, showAdd: false });
                    this.props.actions.clearProfileGigs(this.state.profile.ID, this.state.profile.Username);
                })
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }        
    }

    showAdd(event) {
        event.preventDefault();
        this.setState({ showAdd: true });
    }

    closeShowAdd(event) {
        event.preventDefault();
        this.setState({ showAdd: false, newGig: { }, error: null });
    }

    updateGig(event) {
        event.preventDefault();
        if(!this.state.selectedGig.Country) {
            this.setState({ error: "Please enter the event country" });
        }
        else if(!this.state.selectedGig.City) {
            this.setState({ error: "Please enter the event location" });
        }
        else if (!this.state.selectedGig.StartDate) {
            this.setState({ error: "Please enter the event date" });
        }
        else {
            this.setState({ error: null });
            const gig = {...this.state.selectedGig};           
            this.props.actions.updateGig(this.state.profile.ID, gig.ID, gig)
                .then(updatedGig => {
                    const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'The changes have been saved successfully');
                    this.initialise(true);
                }) 
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }
    }

    updateSelectedGigField(event) {
        const name = (event.target.name || event.target.attributes['name'].value);
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.dataset.val;// event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const selectedGig = {...this.state.selectedGig};
        selectedGig[name] = value;
        this.setState({ selectedGig }, () => {
            if(name === 'Country' && value) {
                this.initialiseVenueAutoCompleteSelectedGig();
            }
        });
    }

    updateNewGigField(event) {
        const name = (event.target.name || event.target.attributes['name'].value);
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.dataset.val;// event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const newGig = {...this.state.newGig};
        newGig[name] = value;
        this.setState({ newGig }, () => {
            if(name === 'Country' && value) {
                this.initialiseVenueAutoCompleteNewGig();
            }
        });
    }

    locationSearch(query) {
        this.setState({locationTypeaheadLoading: true});
        LocationService.searchLocation('', false, true, query)
        .then(items => {
            this.setState({
                locationTypeaheadLoading: false,
                locationTypeaheadOptions: items
            });
        } );
    }

    locationSelected(items) {
        //this.props.actions.updateLocation(items);        
    }

    getEventBriteLink() {
        return '/go/eventbrite';
    }

    initialiseVenueAutoCompleteNewGig() {
        const updateCallback = (placeName, address, city, state, latitude, longitude, fieldName) => {
            //take in the various fields as arguments and update the newGig object in state
            const newGig = {...this.state.newGig};
            if(fieldName === 'Venue') {
                newGig.Venue = placeName;
            }            
            newGig.Address = address;
            newGig.City = city;
            newGig.State = state;
            newGig.Latitude = latitude;
            newGig.Longitude = longitude;
            this.setState({ newGig });
        };
        this.initialiseVenueAutoComplete(this.state.newGig.Country, updateCallback);
    }

    initialiseVenueAutoCompleteSelectedGig() {
        const updateCallback = (placeName, address, city, state, latitude, longitude, fieldName) => {
            //take in the various fields as arguments and update the selectedGig object in state
            const selectedGig = {...this.state.selectedGig};
            if(fieldName === 'Venue') {
                selectedGig.Venue = placeName;
            }            
            selectedGig.Address = address;
            selectedGig.City = city;
            selectedGig.State = state;
            selectedGig.Latitude = latitude;
            selectedGig.Longitude = longitude;
            this.setState({ selectedGig });
        };
        this.initialiseVenueAutoComplete(this.state.selectedGig.Country, updateCallback);
    }

    initialiseVenueAutoComplete(country, updateCallback) {
        const venue = this.venueInput;
        const address = this.addressInput;
        const optionsVenue = {
            componentRestrictions: { country }
        };
        const optionsAddress = {
            componentRestrictions: { country }
        };     

        let attempts = 0;
        const initAutoCompleteWhenReady = () => {
            if(window.google) {
                const autocompleteVenue = new google.maps.places.Autocomplete(venue, optionsVenue);
                google.maps.event.addListener(autocompleteVenue, 'place_changed', () => {
                    const place = autocompleteVenue.getPlace();
                    this.processPlaceGigVenue(place, venue.name, updateCallback);
                });
                const autocompleteAddress = new google.maps.places.Autocomplete(address, optionsAddress);
                google.maps.event.addListener(autocompleteAddress, 'place_changed', () => {
                    const place = autocompleteAddress.getPlace();
                    this.processPlaceGigVenue(place, address.name, updateCallback);
                });
            }
            else if(attempts < 10) {
                window.setTimeout(initAutoCompleteWhenReady, 1000);
                attempts++;
            }                
        };
        initAutoCompleteWhenReady();   
    }

    processPlaceGigVenue(place, field, updateCallback) {
        const componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            postal_town: 'long_name',
            administrative_area_level_2: 'long_name',
            sublocality_level_1: 'long_name',
            administrative_area_level_1: 'long_name',
            country: 'long_name',
            postal_code: 'short_name'
        };
        let placeName = place.name;
        let placeStreetNumber;
        let placeRoute;
        let placeDistrict;
        let placeCity;
        let placeState;
        let placeCountry;
        let placePostalCode;
        for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                let val = place.address_components[i][componentForm[addressType]];
                if (addressType == 'street_number') {
                    placeStreetNumber = val;
                }
                else if (addressType == 'route') {
                    placeRoute = val;
                }
                else if (addressType == 'sublocality_level_1' || addressType == 'administrative_area_level_2') {
                    placeDistrict = val.replace('City of London', 'London');
                }
                else if (addressType == 'locality' || addressType == 'postal_town') {
                    placeCity = val;
                }
                else if (addressType == 'administrative_area_level_1') {
                    placeState = val;
                }
                else if (addressType == 'country') {
                    placeCountry = val;
                }
                else if (addressType == 'postal_code') {
                    placePostalCode = val;
                }
            }
        }
        if (placeCity == undefined) {
            placeCity = placeDistrict;
        }
        let address = '';
        if (placeStreetNumber != undefined) {
            address = placeStreetNumber + ' ';
        }
        if (placeRoute != undefined) {
            address += placeRoute + ', ';
        }
        if (placeCity != undefined) {
            address += placeCity + ', ';
        }
        if (placeState != undefined) {
            address += placeState + ', ';
        }
        if (placeCountry != undefined) {
            address += placeCountry + ', ';
        }
        if (placePostalCode != undefined) {
            address += placePostalCode + ', ';
        }
        updateCallback(placeName, address.substring(0, address.length - 2), placeCity, placeState, place.geometry.location.lat(), place.geometry.location.lng(), field);
    }

    render() {
        return (
            !ArtistService.showGigs(this.props.profile.RoleType) ?
                <Redirect to="/Profile/Manage" />
                :
                !this.state.selectedGig ? 
                    <div id="divCreateProfile">    
                        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />                    
                        {
                            this.state.showAdd ?                                
                                <form id="frmAddGig" className="form-tightfields form-regular" onSubmit={this.addGig}>                                    
                                    <a href="#" style={{float:'right'}} onClick={this.closeShowAdd}>Close</a>
                                    <p style={{fontWeight: 'bold', textAlign: 'center'}}>Add new gig</p>
                                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                    <MaterialInput name="Title" label="Event Name" value={this.state.newGig.Title} onChange={this.updateNewGigField} required maxLength="50" />
                                    <MaterialInput name="Description" value={this.state.newGig.Description} onChange={this.updateNewGigField} maxLength="200" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <MaterialInput name="StartDate" label="Start Date" className={this.state.newGig.StartDate ? 'is-dirty' : ''} value={this.state.newGig.StartDate ? this.state.newGig.StartDate.format('DD MMM YYYY HH:mm') : ''} readOnly inputRef={(control) => this.startDateControl = control} />
                                        </div>
                                        <div className="col-md-6">
                                            <MaterialInput name="EndDate" label="End Date" className={this.state.newGig.EndDate ? 'is-dirty' : ''} value={this.state.newGig.EndDate ? this.state.newGig.EndDate.format('DD MMM YYYY HH:mm') : ''} readOnly inputRef={(control) => this.endDateControl = control} />           
                                        </div>
                                    </div>
                                    <MaterialDropDown 
                                        name="Country" 
                                        className={`getmdl-select__fullwidth getmdl-select--limited placeholder ${this.state.newGig.Country ? 'is-dirty': ''}`}
                                        data={this.props.countries}
                                        value={this.state.newGig.Country ? this.props.countries.find(c => c.Code === this.state.newGig.Country).Name : ''} 
                                        readOnly 
                                        required
                                        itemValueFunc={(country) => country.Code}
                                        itemTextFunc={(country) => country.Name}
                                        onClick={this.updateNewGigField} />
                                    <MaterialInput name="Venue" className={!this.state.newGig.Country ? 'is-disabled' : 'is-dirty'} placeholder="Type venue name to search..." disabled={!this.state.newGig.Country} inputRef={(control) => this.venueInput = control} required />
                                    <MaterialInput name="Address" className={!this.state.newGig.Country ? 'is-disabled' : 'is-dirty'} placeholder="Type an address to search..." disabled={!this.state.newGig.Country} ref={(control) => this.addressInput = control} value={this.state.newGig.Address} onChange={this.updateNewGigField} required />
                                    <MaterialInput name="TicketPrice" label="Ticket Price Info" value={this.state.newGig.TicketPrice} onChange={this.updateNewGigField} maxLength="100" required />
                                    <MaterialInput name="TicketSalesLink" label="Ticket Sale Url" type="url" value={this.state.newGig.TicketSalesLink} onChange={this.updateNewGigField} maxLength="150" />
                                    <a href={this.getEventBriteLink()} className="transition" target="_blank" rel="nofollow">
                                        Sell tickets for your gig online using Eventbrite.
                                    </a>
                                    <br />
                                    <br />
                                    <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" value="ADD" onClick={this.addVideo} />                                  
                                </form>
                            : 
                                <React.Fragment>
                                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                    <a id="aAddNewGig" href="#" className="btn-simple transition" onClick={this.showAdd} style={{display: this.state.gigs.length < 8 ? 'inline' : 'none'}}>Add new gig →</a>                       
                                    <div id="loudUpVideos">                        
                                        <p className="formlegend">Gigs added to LoudUp</p>
                                        <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                                        <div className="table-responsive">
                                            <table id="uploaded" className="table table-striped table-results gig-listings">
                                                <thead>
                                                    <tr>
                                                        <th>EVENT NAME</th>
                                                        <th>START DATE</th>
                                                        <th>END DATE</th>
                                                        <th>CITY</th>
                                                        <th>VENUE</th>
                                                        <th>TICKET PRICE</th>
                                                        <th>TICKET SALE LINK</th>
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.gigs.length ?
                                                            this.state.gigs.map(gig => 
                                                                <tr key={gig.ID} className="transition">
                                                                    <td>
                                                                        {gig.Title}
                                                                    </td>
                                                                    <td>
                                                                        {new Date(gig.StartDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}
                                                                    </td>
                                                                    <td>
                                                                        { gig.EndDate ? new Date(gig.EndDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' }) : ''}
                                                                    </td>
                                                                    <td>
                                                                        {textUtils.formatLocation(gig.City, gig.Region, gig.Country)}
                                                                    </td>
                                                                    <td>
                                                                        {gig.Venue}
                                                                    </td>
                                                                    <td>
                                                                        {gig.TicketPrice}
                                                                    </td>
                                                                    <td>
                                                                        <a href={gig.TicketSaleLink} target="_blank">{gig.TicketSaleLink}</a>
                                                                    </td>
                                                                    <td>
                                                                        <a href="#" className="btn-simple transition" onClick={(e) => this.editGig(e, gig)}>Edit</a>
                                                                    </td>
                                                                    <td>
                                                                        <a href="#" className="btn-simple transition" onClick={(e) => this.removeGig(e, gig)}>Remove</a>
                                                                    </td>
                                                                </tr>   
                                                            )                                            
                                                        : 
                                                        <tr>
                                                            <td colSpan="9" style={{textAlign: 'center'}}>
                                                                {
                                                                    this.state.loadingGigs ? 
                                                                        <Loading /> 
                                                                        : 'No upcoming gigs saved'
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>                                   
                                </React.Fragment>
                        }                        
                    </div>   
                :            
                    <div id="editGig" className="form form-block">
                        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" /> 
                        <a href="#" style={{float:'right'}} onClick={this.closeEditGig}>Close</a>
                        <p style={{fontWeight: 'bold'}}>Edit Gig</p>
                        <form id="frmEditGig" className="form-tightfields form-regular" onSubmit={this.updateGig}>
                            <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                            <MaterialInput name="Title" label="Event Name" value={this.state.selectedGig.Title} onChange={this.updateSelectedGigField} required maxLength="50" />
                            <MaterialInput name="Description" value={this.state.selectedGig.Description} onChange={this.updateSelectedGigField} maxLength="200" />
                            <div className="row">
                                <div className="col-md-6">
                                    <MaterialInput name="StartDate" label="Start Date" className={this.state.selectedGig.StartDate ? 'is-dirty' : ''} value={this.state.selectedGig.StartDate ? this.state.selectedGig.StartDate.format('DD MMM YYYY HH:mm') : ''} readOnly inputRef={(control) => this.startDateControl = control} />
                                </div>
                                <div className="col-md-6">
                                    <MaterialInput name="EndDate" label="End Date" className={this.state.selectedGig.EndDate ? 'is-dirty' : ''} value={this.state.selectedGig.EndDate ? this.state.selectedGig.EndDate.format('DD MMM YYYY HH:mm') : ''} readOnly ref={(control) => this.endDateControl = control} />
                                </div>
                            </div>
                            <MaterialDropDown 
                                name="Country"
                                className={`getmdl-select__fullwidth getmdl-select--limited placeholder ${this.state.selectedGig.Country ? 'is-dirty': ''}`}
                                value={this.state.selectedGig.Country ? this.props.countries.find(c => c.Code === this.state.selectedGig.Country).Name : ''} 
                                readOnly 
                                required
                                data={this.props.countries}
                                onChange={this.updateSelectedGigField}
                                itemTextFunc={(country) => country.Name}
                                itemValueFunc={(country) => country.Code} />
                            <MaterialInput name="Venue" className={!this.state.selectedGig.Country ? 'is-disabled' : 'is-dirty'} placeholder="Type venue name to search..." value={this.state.selectedGig.Venue} onChange={this.updateSelectedGigField} disabled={!this.state.selectedGig.Country} inputRef={(control) => this.venueInput = control} required />
                            <MaterialInput name="Address" className={!this.state.selectedGig.Country ? 'is-disabled' : 'is-dirty'} placeholder="Type an address to search..." disabled={!this.state.selectedGig.Country} inputRef={(control) => this.addressInput = control} value={this.state.selectedGig.Address} onChange={this.updateSelectedGigField} required />
                            <MaterialInput name="TicketPrice" label="Ticket Price Info" value={this.state.selectedGig.TicketPrice} onChange={this.updateSelectedGigField} maxLength="100" required />
                            <MaterialInput name="TicketSalesLink" label="Ticket Sale Url" value={this.state.selectedGig.TicketSalesLink} onChange={this.updateSelectedGigField} maxLength="150" />                          
                            <input type="submit" value="Save" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" />                   
                        </form>
                    </div>                
        );
    }
}

EditSeeMe.propTypes = {
    countries: PropTypes.array,
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default EditSeeMe;